import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../components/header/Header';
import { Footer } from '../components/footer/Footer';
import { Sidebar } from '../components/nav/Sidebar';
import { MobileNavDrawer } from '../components/nav/MobileNavDrawer';
import { Notification } from '../components/common/Notification';

// Persistent in-app chrome (all routes except the landing): header, sidebar/drawer nav,
// footer, and the routed content. Landmark regions + a skip link satisfy the a11y floor.
export const AppLayout = () => (
    <div className="flex min-h-screen flex-col bg-canvas">
        <a
            href="#main"
            className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-canvas focus:px-3 focus:py-2 focus:text-ink focus:outline focus:outline-2 focus:outline-tone-950"
        >
            Skip to content
        </a>
        <Header />
        <div className="flex flex-1">
            <Sidebar />
            <main id="main" tabIndex={-1} className="min-w-0 flex-1 px-8 py-8 md:px-10">
                <Outlet />
            </main>
        </div>
        <Footer />
        <MobileNavDrawer />
        <Notification />
    </div>
);
